import Navigator from 'app';
import BillModel from './bill_model';
const BillCollection = Backbone.Collection.extend({
  model: BillModel,
  url: Navigator.config.api_base + 'bills'
});
const API = {
  getBills: function () {
    var defer = $.Deferred();
    var bills = new BillCollection();
    bills.fetch({
      dataType: "jsonp",
      success: function (data) {
        defer.resolve(data);
      }
    });
    return defer.promise();
  },
  getBillsByEvent: function (event) {
    var defer = $.Deferred();
    var bills = new BillCollection();
    bills.url += '/' + event;
    bills.fetch({
      dataType: "jsonp",
      success: function (data) {
        defer.resolve(data);
      }
    });
    return defer.promise();
  }
};
Navigator.reqres.setHandler("bills:list", function () {
  return API.getBills();
});
Navigator.reqres.setHandler("bills:list:byevent", function (event) {
  return API.getBillsByEvent(event);
});
export { BillCollection as default };